module.exports = __webpack_public_path__ + "img/nav03.7958124e.png";